import { PageLink } from '../../../_start/layout/core';

export const formManagementSubmenu: Array<PageLink> = [
  {
    title: 'Cancellations',
    path: '/form-management/cancellations',
    isActive: true,
  },
  {
    title: 'Company Changes',
    path: '/form-management/company-changes',
    isActive: false,
  },
];
